<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="2"></b-col>
                <b-col md="8">
                  <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="id_tipo_cliente"
                        label-for="id_tipo_cliente"
                        label="Classificação"
                      >
                        <b-form-select
                          v-model="$v.form.id_tipo_cliente.$model"
                          :state="validateState('id_tipo_cliente')"
                        >
                          <b-form-select-option :value="1">
                            Cliente Final
                          </b-form-select-option>
                          <b-form-select-option :value="2">
                            Revenda
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group
                        id="produto"
                        label-for="produto"
                        label="Produto"
                      >
                        <b-form-select
                          v-model="produto"
                        >
                          <b-form-select-option v-for="(p, index) in produtos" :key="'produto'+ index" :value="p">
                            {{ p.descricao }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group
                        id="qtd"
                        label-for="qtd"
                        label="Qtd"
                      >
                        <input
                          class="form-control"
                          v-model="$v.form.qtd.$model"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group
                        id="valor"
                        label-for="valor"
                        label="Valor por UN"
                      >
                        <money
                          class="form-control"
                          v-model="form.valor"
                          v-bind="configMoney"
                        >
                        </money>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_valor"
                class="btn btn-primary mr-2"
              >
                Salvar
              </button>
              <button
                type="button"
                v-on:click="
                  () => {
                    $router.go(-1);
                  }
                "
                class="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import ProdutosValorData, { ProdutosValorDataRequired } from "./Data";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "app-config-renovacoes-valor-form",
  props: {
    url: {
      type: String,
    },
    valor: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, ApplicationMixin],
  components: {
    Money,
  },
  data() {
    return {
      configMoney: settingMoney,
      tabIndex: 0,
      form: {},
      revendas: {},
      produto: [],
      produtos: [],
    };
  },
  validations: {
    form: ProdutosValorDataRequired,
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async getProdutos() {
      try {
        const { data } = await this.$http.post('/renovacoes/produtos');
        this.produtos = data;
      } catch (error) {
        this.produtos = [];
      }
    },
    async getRevendas() {
      try {
        const { data } = await this.$http.post("/renovacoes/revendas");
        this.revendas = data;
      } catch {
        return [];
      }
    },
    async getDataInit() {
      this.getRevendas();
      await this.getProdutos();

      if (this.valor.id) {
        this.form = this.valor;
        this.form.valor = this.numberToReal(this.form.valor);
        this.produto = this.produtos.find(p => p.produto == this.form.produto)
        return;
      }

      this.form = new ProdutosValorData({});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_valor"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        if (!this.produto.produto) {
          return this.$toast.error("Informe um produto!");
        }

        this.form.produto = this.produto.produto;

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        await this.$http.post(this.url, this.form);

        this.$toast.success("Operação realizada com suceso!");

        this.$router.push({ name: "configuracoesRenovacaoLicencasLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
